export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "htmldiff.worker.f5b9c2e8f78ef10ac6c8.worker.js");
}
